import React from 'react';

import PropTypes from 'prop-types';
import { Search as UDSSearch } from '@telus-uds/components-web';

const Search = ({ queryString, setQueryString }) => {
  return (
    <div style={{ width: '100%', maxWidth: '400px', justifySelf: 'flex-end' }}>
      <UDSSearch
        label="Search"
        placeholder="Search by First Name, Last Name, Email, CPMS ID or XID/TID"
        value={queryString}
        onChange={(value) => setQueryString(value)}
      />
    </div>
  );
};
Search.propTypes = {
  queryString: PropTypes.string.isRequired,
  setQueryString: PropTypes.func.isRequired
};
export default Search;
